export function getReviewerFormattedName(reviewerName: string) {
  if (reviewerName === 'Belong M.') {
    return '';
  }

  const splittedReviewerName = reviewerName?.split(' ');
  const firstName = splittedReviewerName[0];
  const lastName = splittedReviewerName[splittedReviewerName.length - 1];
  const lastNameFirstLetter = lastName?.charAt(0);

  return lastName ? `${firstName} ${lastNameFirstLetter}.` : firstName;
}
